export default "__VITE_ASSET__BCEQYM7j__"